/**
 * Angular imports.
 */
import { Component, ElementRef, Input, ViewChild, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { STORY_DEFAULT_DURATION } from 'src/app/constants/app.constants';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Service imports.
 */
import { TimeService } from '../../services/timer.service';

/**
 * Progress bar calculation.
 */
@Component({
  selector: 'app-story-progress-bar',
  templateUrl: './story-progress-bar.component.html',
  styleUrls: ['./story-progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoryProgressBarComponent  {

  /**
   * Element reference of the progress bar.
   */
  @ViewChild('progressBar', { static: true }) progressBar: ElementRef;

  /**
   * Get the duration of the story.
   * Is story active flag.
   * Is story completed flag.
   */
  @Input() duration: number;
  @Input() isActive: boolean;
  @Input() completed: boolean;
  @Input() storyProgressPercentage: string;


  public defaultDuration = STORY_DEFAULT_DURATION;

  /**
   * Call the calculate progress bar percentage function.
   */
  constructor(private timerService: TimeService) {
  }

}

